import { Component } from 'src/utils';
import template from './store-selector.html';

@Component({
  controllerAs: 'store',
  template
})

export default class storeSelector {

  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'authService',
    '$cookies'

  ];

  constructor($scope, $ngRedux, $state, $auth, $cookies) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$state = $state;
    this.$auth = $auth;
    let guestStore = null;
    try {
      guestStore = sessionStorage.getItem('guestStoreName');
    }
    catch (e) {
      guestStore = $cookies.get('guestStoreName');
    }
    this.$auth.getStoreDetail(guestStore);
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    let obj = {
      profile: state.auth.profile,
      list: state.order.categories
    };
    if (!obj.profile.store) {
      obj.profile = {'store': state.auth.storeDetail};
    }
    return obj;
  }
  doLogout() {
    this.$auth.logout(this.profile);
  }
  goTo() {
    // console.log('go to');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/store-selector/store-selector.js